export default {
  de: {
    true: 'Ja',
    false: 'Nein',
  },
};
